/**
 * Types catalogue paramétrable — alias FE typés sur le codegen OpenAPI.
 *
 * Trois entités symétriques alimentant les variantes d'œuvres (cf.
 * `work_variants` en S2.5b). Page `/settings` permet à Stéphanie de
 * peupler son catalogue avant de créer ses variantes.
 */

import type { components } from './api-generated'

// ── Formats ───────────────────────────────────────────────────────────────────
export type FormatResponse = components['schemas']['FormatResponse']
export type FormatCreateRequest = components['schemas']['FormatCreateRequest']
export type FormatUpdateRequest = components['schemas']['FormatUpdateRequest']
export type FormatKind = components['schemas']['FormatKind']

// ── Framings ──────────────────────────────────────────────────────────────────
export type FramingResponse = components['schemas']['FramingResponse']
export type FramingCreateRequest = components['schemas']['FramingCreateRequest']
export type FramingUpdateRequest = components['schemas']['FramingUpdateRequest']

// ── Supports ──────────────────────────────────────────────────────────────────
export type SupportResponse = components['schemas']['SupportResponse']
export type SupportCreateRequest = components['schemas']['SupportCreateRequest']
export type SupportUpdateRequest = components['schemas']['SupportUpdateRequest']

// Refonte POD v6.1 : `PodCategory` retiré du domaine A (lexique artistique).
// La catégorisation produit Gelato vit désormais dans `pod_sku_catalog`
// (domaine C, opaque côté FE — accessible via `printable_specs`).

// ── Emotional intents (Tier 2 — paramétrable S2.5c) ─────────────────────────
export type EmotionalIntentResponse = components['schemas']['EmotionalIntentResponse']
export type EmotionalIntentCreateRequest = components['schemas']['EmotionalIntentCreateRequest']
export type EmotionalIntentUpdateRequest = components['schemas']['EmotionalIntentUpdateRequest']

// ── Target audiences (Tier 2 — paramétrable S2.5c) ──────────────────────────
export type TargetAudienceResponse = components['schemas']['TargetAudienceResponse']
export type TargetAudienceCreateRequest = components['schemas']['TargetAudienceCreateRequest']
export type TargetAudienceUpdateRequest = components['schemas']['TargetAudienceUpdateRequest']

// ── Slug suggestion (Claude — Tier 2) ───────────────────────────────────────
export type SlugSuggestRequest = components['schemas']['SlugSuggestRequest']
export type SlugSuggestResponse = components['schemas']['SlugSuggestResponse']
export type SlugSuggestKind = SlugSuggestRequest['kind']

// ── Lookups FR (slugs neutres EN -> labels FR pour l'UI atelier) ──────────────

export const FORMAT_KIND_FR: Record<FormatKind, string> = {
  print: 'Tirage',
  original: 'Original',
  custom: 'Sur mesure',
  digital: 'Digital download',
}

export const FORMAT_KIND_OPTIONS: FormatKind[] = ['print', 'original', 'custom', 'digital']
